import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyStateIcon } from 'application/assets/empty-state.svg';
import { StyledTr } from './styles';

const NoDataElement: FC = () => {
  const { t } = useTranslation();
  return (
    <StyledTr>
      <td colSpan={3}>
        <div>
          <EmptyStateIcon />
          <p>{t('clinics_management.no_data')}</p>
        </div>
      </td>
    </StyledTr>
  );
};
export default NoDataElement;
